"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWebSocketsTransport = void 0;
const tslib_1 = require("tslib");
const isomorphic_ws_1 = tslib_1.__importDefault(require("isomorphic-ws"));
const mitt_1 = tslib_1.__importDefault(require("mitt"));
function createWebSocketsTransport(url) {
    let socket;
    const events = (0, mitt_1.default)();
    const connect = function () {
        socket = new isomorphic_ws_1.default(url);
        socket.binaryType = 'arraybuffer';
        // On close event
        socket.addEventListener('close', () => events.emit('close', {}), {
            once: true
        });
        if (socket.readyState === socket.OPEN) {
            events.emit('connect', { socket });
        }
        else {
            socket.addEventListener('open', () => events.emit('connect', { socket }), { once: true });
        }
        // On error event
        socket.addEventListener('error', (err) => {
            if (err.error) {
                events.emit('error', err.error);
            }
            else if (err.message) {
                events.emit('error', Object.assign(new Error(err.message), {
                    colno: err.colno,
                    error: err.error,
                    filename: err.filename,
                    lineno: err.lineno,
                    message: err.message
                }));
            }
        });
        // On message
        socket.addEventListener('message', (message) => {
            // Check if the message is a string and what to do with it
            if (message.data instanceof ArrayBuffer) {
                events.emit('message', new Uint8Array(message.data));
            }
        });
    };
    const send = function (message) {
        if (socket && socket.readyState === socket.OPEN) {
            if (message instanceof Uint8Array || message instanceof ArrayBuffer) {
                socket.send(message);
            }
            else {
                const msg = JSON.stringify({
                    type: message.type,
                    payload: message.payload
                });
                socket.send(msg);
            }
        }
    };
    connect();
    return {
        ...events,
        get isConnected() {
            return (socket && socket.readyState === socket.OPEN) || false;
        },
        sendMessage(message) {
            send(message);
        },
        close() {
            if (socket)
                socket.close();
        }
    };
}
exports.createWebSocketsTransport = createWebSocketsTransport;
//# sourceMappingURL=transport.js.map